// postfix JE - jQuery Element
(function () {
	const testimonials = () => {
		$(document).ready(function () {
			$(".js-get-testimonials").each(function (index, parent) {
				let parentId = `#${$(parent).attr("id")}`;
				// prettier-ignore
				let testimonialsCarousel = document.querySelector(parentId).querySelector(`.js-ts-slider`);
				// prettier-ignore
				let testimonialsCarouselNext = document.querySelector(parentId).querySelector(".js-ts-slider__arrow--next");
				// prettier-ignore
				let testimonialsCarouselPrev = document.querySelector(parentId).querySelector(".js-ts-slider__arrow--prev");

				// prettier-ignore
				let testimonialsSlider = document.querySelector(parentId).querySelector(`.js-swiper-testimonials`);
				// prettier-ignore
				let testimonialsSliderNext = document.querySelector(parentId).querySelector(".js-testimonials-carousel-arrow-prev");
				// prettier-ignore
				let testimonialsSliderPrev = document.querySelector(parentId).querySelector(".js-testimonials-carousel-arrow-next");
				// prettier-ignore
				let testimonialsSliderScrollBar = document.querySelector(parentId).querySelector(".js-testimonials-swiper-scrollbar");
				// prettier-ignore
				//let testimonialsSliderPagination = document.querySelector(parentId).querySelector(".js-testimonials-swiper-scrollbar");

				const Carousel = new Swiper(testimonialsCarousel, {
					parallax: true,
					slidesPerView: 1,
					centeredSlides: true,
					speed: 1000,
					navigation: {
						prevEl: testimonialsCarouselPrev,
						nextEl: testimonialsCarouselNext,
					},
				});

				//
				const Slider = new Swiper(testimonialsSlider, {
					slidesPerView: 3,
					slidesPerGroup: 3,
					centeredSlides: false,
					speed: 1000,
                    spaceBetween: 20,
					navigation: {
						prevEl: testimonialsSliderPrev,
						nextEl: testimonialsSliderNext,
					},

					scrollbar: {
						el: testimonialsSliderScrollBar,
						draggable: true,
					},

					breakpoints: {
						0: {
							slidesPerView: 1,
							slidesPerGroup: 1,
                            spaceBetween: 10,
						},
                        350: {
							slidesPerView: 2,
							slidesPerGroup: 1,
                            spaceBetween: 10,
						},
						544: {
							slidesPerView: 3,
							slidesPerGroup: 1,
                            spaceBetween: 10,
						},
                        768: {
							slidesPerView: 4,
							slidesPerGroup: 1,
                            spaceBetween: 10,
						},
						992: {
							slidesPerView: 5,
							slidesPerGroup: 1,
                            spaceBetween: 10,
						},
						1200: {
							slidesPerView: 6,
							// slidesPerGroup: 3,
						},
						1800: {
							slidesPerView: 6,
							// slidesPerGroup: 3,
						},
					},
				});
				if (document.querySelector(".testimonials_nav-tools")) {
					if (
						testimonialsSliderNext &&
						testimonialsSliderNext.hasAttribute("disabled") &&
						testimonialsSliderPrev.hasAttribute("disabled")
					) {
                      // Assuming you have an array of elements or a NodeList
                      const testimonialsNavToolsList = document.querySelectorAll(".testimonials_nav-tools");
                      
                      // Loop through each element and set its display property
                      for (let i = 0; i < testimonialsNavToolsList.length; i++) {
                          testimonialsNavToolsList[i].style.display = "none";
                      }
					} else {
                      // Assuming you have an array of elements or a NodeList
                      const testimonialsNavToolsList = document.querySelectorAll(".testimonials_nav-tools");
                      
                      // Loop through each element and set its display property
                      for (let i = 0; i < testimonialsNavToolsList.length; i++) {
                          testimonialsNavToolsList[i].style.display = "flex";
                      }
					}
				} else {
                  console.log("arrow length check===================================================");
                }
			});
		});
	};

	//.js-swiper-product-carousel
	document.addEventListener("DOMContentLoaded", function () {
		testimonials();
		document.addEventListener("shopify:section:load", function () {
			testimonials();
		});
	});

	window.addEventListener("resize", function () {
		testimonials();
	});
})();
